import { AuditSelectionType as AuditType } from "src/graphql/quark/quark.type"

/**
 * Color mapping for audit types following Material-UI semantic colors
 */
export const getAuditTypeColor = (type: AuditType | string) => {
  switch (type) {
    case AuditType.All:
      return "primary" // Blue - Comprehensive/Default
    case AuditType.HighSelling:
      return "success" // Green - Positive performance
    case AuditType.LowSelling:
      return "warning" // Orange - Needs attention
    case AuditType.Random:
      return "info" // Light blue - Neutral/Informational
    case AuditType.SpecificProduct:
      return "secondary" // Purple - Specific/Targeted
    default:
      return "default" // Grey - Unknown/Fallback
  }
}

/**
 * Get display label for audit type
 */
export const getAuditTypeLabel = (type: AuditType | string) => {
  switch (type) {
    case AuditType.All:
    case "ALL":
      return "All Products"
    case AuditType.HighSelling:
    case "HIGH_SELLING":
      return "High Selling"
    case AuditType.LowSelling:
    case "LOW_SELLING":
      return "Low Selling"
    case AuditType.Random:
    case "RANDOM":
      return "Random"
    case AuditType.SpecificProduct:
    case "SPECIFIC_PRODUCT":
      return "Specific Product"
    default:
      return type?.replace("_", " ") || "Unknown"
  }
}

/**
 * Get icon for audit type (optional - for future use)
 */
export const getAuditTypeIcon = (type: AuditType | string) => {
  switch (type) {
    case AuditType.All:
    case "ALL":
      return "inventory" // All inventory
    case AuditType.HighSelling:
    case "HIGH_SELLING":
      return "trending_up" // High performance
    case AuditType.LowSelling:
    case "LOW_SELLING":
      return "trending_down" // Low performance
    case AuditType.Random:
    case "RANDOM":
      return "shuffle" // Random selection
    case AuditType.SpecificProduct:
    case "SPECIFIC_PRODUCT":
      return "search" // Targeted selection
    default:
      return "help"
  }
}
